import { Helmet } from 'react-helmet-async';
import AppButton from 'src/components/common/AppButton';
import AppLoadingAndErrorWrapper from 'src/components/common/AppLoadingAndErrorWrapper';
import { ConfirmDialog } from 'src/components/custom-dialog';
import AppTable from 'src/components/table/app-table';
import { FINISHED_SCHOOLS_COUNCILS_ANALYSIS_TABLE_HEAD } from 'src/constants/tables-heads';
import { HearingCouncilAnalysisQuery } from 'src/graphql';
import useFinishedHearingCouncilsSchoolsUsers from './use-finished-hearing-councils-schools-users';

const FinishedHearingCouncilsSchoolsUsers = ({
  certificateHearingCouncilId,
}: {
  certificateHearingCouncilId: string;
}) => {
  const {
    isLoading,
    t,
    table,
    columns,
    methods,
    query,
    setQuery,
    handleSearch,
    confirm,
    isCreatingCert,
    data,
    handleExportSelectedCert,
    confirmExportSelected,
    handleExportUserCertificate,
    selectProps,
  } = useFinishedHearingCouncilsSchoolsUsers({ certificateHearingCouncilId });

  const viewComponent = (
    <>
      <AppTable<HearingCouncilAnalysisQuery['user_hearing_councils'][0]>
        data={data?.user_hearing_councils!}
        columns={columns}
        dataCount={data?.user_hearing_councils_aggregate.aggregate?.count!}
        headLabels={FINISHED_SCHOOLS_COUNCILS_ANALYSIS_TABLE_HEAD(t)}
        table={table}
        isLoading={isLoading}
        handleSearch={handleSearch}
        // Select action props
        select={selectProps}
        // end
        setQuery={setQuery}
        query={query}
        methods={methods}
      />
      <ConfirmDialog
        open={confirm.value || confirmExportSelected.value}
        onClose={(event: React.SyntheticEvent<Element, Event>, reason: string) => {
          if (reason && reason === 'backdropClick') {
            confirm.onFalse();
            confirmExportSelected.onFalse();
          }
        }}
        content={t('dialogs.confirmMessage', {
          editOrAdd: t('buttons.add').toLowerCase(),
        })}
        action={
          <>
            <AppButton
              fullWidth
              label={t('publicWords.no')}
              variant="outlined"
              onClick={() => {
                confirm.onFalse();
                confirmExportSelected.onFalse();
              }}
            />
            <AppButton
              fullWidth
              label={t('publicWords.yes')}
              isLoading={isCreatingCert}
              onClick={() => {
                confirmExportSelected.value
                  ? handleExportSelectedCert()
                  : handleExportUserCertificate();
              }}
            />
          </>
        }
      />
    </>
  );

  return (
    <AppLoadingAndErrorWrapper isLoading={false}>
      <Helmet>
        <title>{t('titles.hearingCouncilAnalysis')}</title>
      </Helmet>
      {viewComponent}
    </AppLoadingAndErrorWrapper>
  );
};

export default FinishedHearingCouncilsSchoolsUsers;
